<template>
  <div class="default-headers">
    <nav class="navbar navbar-inverse nav-justified" role="navigation">
      <div class="container">
        <div class="navbar-header">
          <div class="span">
            <button class="text-left click-to-call" id="toggle-click-to-call" type="button">Call Us</button>
            <a class="mobile-directions track-click" data-action="Address Click" data-category="Hours &amp; Directions" data-label="Dealership Address Link" href="#" itemprop="hasMap">Directions</a>
            <button class="navbar-toggle" data-target="#navbar-ex1-collapse" data-toggle="collapse" type="button">
              <span class="navbar-toggle-title">Menu</span>
            </button>
          </div>
        </div>
        <div class="collapse navbar-collapse" id="navbar-ex1-collapse">
          <ul class="nav navbar-nav" data-more-dropdown="false" role="menubar">
            <li role="none">
              <a href="#" role="menuitem" target="">Home</a>
            </li>
            <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
              <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="New Vehicles" data-toggle="dropdown" href="#" role="menuitem" target="">New Vehicles</a>
              <ul aria-label="New Vehicles" class="dropdown-menu" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Schedule Test Drive</a>
                </li>
                <li role="none"><a href="#" role="menuitem" target="">Quick Quote</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a>
                </li>
                <li role="none"><a href="#" role="menuitem" target="">Shop Our Ads</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
              <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="Pre-Owned Vehicles" data-toggle="dropdown" href="#" role="menuitem" target="">Pre-Owned Vehicles</a>
              <ul aria-label="Pre-Owned Vehicles" class="dropdown-menu" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Vehicles Under $12,000</a>
                </li>
                <li role="none"><a href="#" role="menuitem" target="">Locate Your Vehicle</a>
                </li>
                <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a>
                </li>
              </ul>
            </li>
            <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
              <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="Specials" data-toggle="dropdown" href="#" role="menuitem" target="">Specials</a>
              <ul aria-label="Specials" class="dropdown-menu" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">New Vehicle Specials</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Pre-Owned Specials</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
              <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="Financing" data-toggle="dropdown" href="#" role="menuitem" target="">Financing</a>
              <ul aria-label="Financing" class="dropdown-menu" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Finance Information</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Finance Application</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
              <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="Service &amp; Parts" data-toggle="dropdown" href="#" role="menuitem" target="">Service &amp; Parts</a>
              <ul aria-label="Service &amp; Parts" class="dropdown-menu" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Service Info</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Service Appointments</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Service Coupons</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Parts Request</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
              <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="About" data-toggle="dropdown" href="#" role="menuitem" target="">About</a>
              <ul aria-label="About" class="dropdown-menu" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Reviews</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Career Opportunities</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Staff Directory</a></li>
              </ul>
            </li>
            <li role="none">
              <a href="#" role="menuitem" target="">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <header class="hidden-xs hidden-sm">
      <div class="full-banner-image"></div>
      <div class="container sub-navigation" itemscope="">
        <div class="row">
          <div class="col-sm-4 text-center">
            <a href="/">
              <img alt="Dealer Logo" class="dealer-logo" :src="[!logoURL ? images.logoExample[0] : logoURL]" title="Dealer Logo">
            </a>
          </div>
          <div class="col-sm-5">
            <div class="search-bar">
              <form action="/vehicles" role="search">
                <div class="input-group">
                  <input aria-label="Search Bar" autocomplete="off" autocorrect="off" class="form-control input-search" data-custom="false" data-placement="bottom" data-search-suggestions="true" data-suggest="true" data-top="Search this site..." name="query" placeholder="Search this site..." spellcheck="false" title="Search this site..." type="text" value=""><input name="new" type="hidden" value="true">
                  <span class="input-group-btn">
                    <button aria-label="search text" class="btn btn-default no-border-left" type="submit">
                      <i aria-hidden="true" class="fa fa-search"></i>
                    </button>
                  </span>
                </div>
              </form>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="contact-and-social">
              <div class="hidden-xs dealer-contact-section">
                <div class="phone">
                  <span>Sales:&nbsp;</span>
                  <a class="track-click dynamic-phone-number sales-phone ws-dynamic-number" href="#">(555) 555-5555</a>
                </div>
                <div class="phone">
                  <span>Service:&nbsp;</span>
                  <a class="track-click dynamic-phone-number sales-phone ws-dynamic-number" href="#">(555) 555-5555</a>
                </div>
                <div class="phone">
                  <span>Parts:&nbsp;</span>
                  <a class="track-click dynamic-phone-number sales-phone ws-dynamic-number" href="#">(555) 555-5555</a>
                </div>
                <div class="address">
                  <a href="#">
                    <span>Hours & Directions</span>
                  </a>
                </div>
              </div>
              <div class="social-media-icons">
                <a aria-label="Facebook" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="Facebook" href="#" target="_blank">
                  <i aria-hidden="true" class="fa fa-facebook"></i>
                </a>
                <a aria-label="Instagram" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="Instagram" href="#" target="_blank">
                  <i aria-hidden="true" class="fa fa-instagram"></i>
                </a>
                <a aria-label="YouTube" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="YouTube" href="#" target="_blank">
                  <i aria-hidden="true" class="fa fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  props: ['images', 'logoURL'],
  data() {
    return {
      sideNavOpen: false,
    };
  },
  mounted() {
  },
  methods: {
    addOpen: function(e) {
      e.target.classList.add("open");
    },
    removeOpen: function(e) {
      e.target.classList.remove("open");
    },
    toggleSideNav: function() {
      this.sideNavOpen = !this.sideNavOpen;
    },
    closeSideNav: function() {
      this.sideNavOpen = false;
    },
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .default-headers {
    font-family: Helvetica, Arial, sans-serif;
  }
  header {
  background: #fff;
  }
  header .well {
    box-shadow: none;
    padding: 0;
    border: 0;
    background: transparent;
  }
  header .logo {
    padding: 0;
  }
  header .logo a {
    font-size: 35px;
  }
  header .logo a:hover {
    text-decoration: none;
  }
  header.above-navigation {
    padding-top: 20px;
  }
  .dealer-logo {
    max-width: 400px;
    max-height: 85px;
    float: none;
  }
.center-header-logo img {
  max-height: 115px;
  max-width: 100%;
  width: auto;
  margin: 0 auto;
}
.search-bar {
  margin: 0 auto;
}
.full-width-search-bar {
  padding: 10px;
  background: #ccc;
}
.contact-and-social {
  padding-left: 20px;
}
.phone {
  color: var(--primary-dark);
  font-size: 15px;
  line-height: 20px;
  text-transform: uppercase;
}
.social-media-icons a {
  color: var(--primary-dark);
  margin-right: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 20px;
}
.address {
  line-height: 20px;
}
.social-media-icons a:hover {
  color: var(--primary-color);
}
.navbar {
  background: #fff;
  border-width: 0;
  margin-bottom: 0;
  border-radius: 0;
}
.navbar li {
  font-size: 15px;
}
.navbar li a {
  color: var(--primary-dark);
}
.navbar-inverse .navbar-nav > .active > a {
  background-color: #fff;
  background-image: none;
  color: var(--primary-color);
}
.navbar-inverse .navbar-nav > .open > a, .navbar-inverse .navbar-nav > .open > a:hover, .navbar-inverse .navbar-nav > .open > a:focus, .navbar-inverse .navbar-nav > li > a:hover {
  background-color: #fff;
  color: var(--primary-color);
}
.dropdown-menu li a:hover, .dropdown-menu > li > a:focus {
  background-image: none;
  background-color: var(--secondary-light);
}
.navbar-inverse .navbar-nav > li > a {
  color: var(--primary-dark);
}
.navbar-nav {
  display: inline-block;
  float: none;
  margin: 0;
}
.navbar-collapse {
  text-align: center;
}
.navbar-toggle, .click-to-call {
  margin: 5px;
  border: none;
  color: #FFFFFF;
  font-size: 20px;
  padding: 5px 15px;
  font-weight: bold;
  background-color: var(--primary-color);
  border-radius: 4px;
}
.mobile-directions {
  margin: 5px;
  height: 38px;
  border: none;
  color: var(--primary-color);
  font-size: 17px;
  font-weight: bold;
  padding: 8px 5px 9px 5px;
  background-color: #fff;
}
.navbar-toggle-title {
  float: right;
}
.sub-navigation {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.search-bar .input-search, .search-bar button {
  height: 50px;
  font-size: 20px;
}
.search-bar .input-search {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.search-bar button {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.search-bar .toggleSearchText {
  font-size: 20px;
}

@media (min-width: 1201px) {
  .default-headers .container {
  max-width: 1185px;
  padding-top: 0;
  padding-bottom: 0;
  }
}

  @media (min-width: 768px) {
    .dealer-logo {
    max-height: 85px;
    max-width: 100%;
    display: block;
    margin: 20px auto 0;
    }
    ul[data-more-dropdown="true"] {
    height: 0;
    overflow-y: hidden;
    float: left;
    white-space: nowrap;
    }
    ul[data-more-dropdown="true"] > li {
    display: inline-block;
    float: none;
    }
    .click-to-call, .mobile-directions {
    display: none;
    }
    .navbar li.nav-dropdown ul li a {
    font-size: 15px;
    text-transform: inherit;
    }
    .nav > li > a {
    padding: 12px 10px;
    font-weight: 400;
    }
    header .search-bar {
    padding-top: 20px;
    } 
    .navbar {
    background: var(--primary-color);
    }
    .navbar-inverse .navbar-nav > li > a {
      color: #fff;
      line-height: 26px;
    }
    .navbar-inverse .navbar-nav > .open > a, .navbar-inverse .navbar-nav > .open > a:hover, .navbar-inverse .navbar-nav > .open > a:focus, .navbar-inverse .navbar-nav > li > a:hover {
      color: var(--primary-color);
      background: #fff;
    }
    #navbar-ex1-collapse {
      height: 50px !important;
    }
  }

  @media (min-width: 768px) and (max-width: 1100px) {
    .navbar li {
    font-size: 11px;
    }
  }

  @media (max-width: 767px) {
    .navbar-inverse .navbar-nav .open .dropdown-menu>li>a, .navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus, .navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover {
      color: var(--primary-dark);
    }
    .navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus, .navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover {
      background: var(--secondary-light);
    }
    .dealer-logo {
      max-width: 100%;
      padding-bottom: 10px;
      max-height: 90px;
      display: block;
    } 
  }

  .default-headers .container {
    padding-top: 0;
    padding-bottom: 0;
  }
</style>